import React, { useEffect, useState, useRef } from 'react';
import SpeedDetails from './SpeedDetails';
import html2canvas from "html2canvas";
import { uploadScreenShotCamera, gptCheckPoint } from '@services/api';
import * as actionTypes from '@redux/actionTypes';
import { useSelector, useDispatch } from "react-redux";
import { Oval } from "react-loader-spinner";
import { mute } from "../Drivepanel/RobotSendData.js";
import { safeLocalStorage } from "@utils/localstorage";
import { getActiveGamepad } from "@utils/gamepad/getActiveGamepad";
let keyboradKeyInterval;
let wheelRemoteInterval;
let pressedKeys = {};
let lightTimeOut, micTimeOut, speakersTimeOut

const Bottomheader = () => {
  const dispatch = useDispatch()
  const audioRef = useRef(null);
  const [loader, setLoader] = useState(false)
  const user = useSelector((state) => state?.setUserDetails?.user);
  const keyboradKey = safeLocalStorage.getItem(`keyboradKey`)
  const wheelKey = safeLocalStorage.getItem(`WheelKey`)
  const remoteKey = safeLocalStorage.getItem(`RemoteKey`)
  const scanCheckPointList = useSelector((state) => state.testDriveDetails.scanCheckPointList)
  const allScanCheckpoint = useSelector((state) => state.testDriveDetails.allScanCheckpoint)
  const gptErrorToast = useSelector((state) => state.testDriveDetails.gptErrorToast)
  const testDriveComplect = useSelector((state) => state.testDriveDetails.testDriveComplect);
  const rideStartTime = useSelector((state) => state.testDriveDetails.rideStartTime)
  const modalIsOpen = useSelector((state) => state.testDriveDetails.modalIsOpen);
  const timeLeft = useSelector((state) => state.testDriveDetails.timeLeft)
  const headlight = useSelector((state) => state.sound.headlight)
  const mic = useSelector((state) => state.sound.mic)
  const audio = useSelector((state) => state.sound.audio)
  const testDriveRideId = useSelector((state) => state.testDriveDetails.testDriveRideId);
  const rulesOpenModel = useSelector((state) => state.loadingSpinner.ruleModel);
  const suspiciousActivityModel = useSelector((state) => state.loadingSpinner.suspiciousActivityModel);
  const otherStateRideStartRef = useRef(rideStartTime);
  const headlightRef = useRef(headlight);
  const micRef = useRef(mic);
  const audiosRef = useRef(audio);
  const testDriveRideIdRef = useRef(testDriveRideId);
  const modalIsOpenRef = useRef(modalIsOpen);
  const isCheckPointScanning = useRef(loader);

  useEffect(() => {
    const userScore = safeLocalStorage.getItem(`score_${user.id}`)
    if (userScore) {
      findAllScanCheckPointAchieveTime(userScore)
      if (scanCheckPointList?.length === 7) {
        dispatch({
          type: actionTypes.TEST_DRIVE_COMPLETE_SEVEN_POINT,
          payload: true
        })
      } else if (scanCheckPointList?.length === 10) {
        dispatch({
          type: actionTypes.TEST_DRIVE_COMPLECT,
          payload: true
        })
      }
    }
  }, [user, scanCheckPointList])

  useEffect(() => {
    testDriveRideIdRef.current = testDriveRideId;
  }, [testDriveRideId]);

  useEffect(() => {
    modalIsOpenRef.current = modalIsOpen;
  }, [modalIsOpen]);

  useEffect(() => {
    isCheckPointScanning.current = loader;
  }, [loader]);

  useEffect(() => {
    otherStateRideStartRef.current = rideStartTime;
  }, [rideStartTime]);

  useEffect(() => {
    headlightRef.current = headlight;
  }, [headlight]);

  useEffect(() => {
    micRef.current = mic;
  }, [mic]);

  useEffect(() => {
    audiosRef.current = audio;
  }, [audio]);

  useEffect(() => {
    if (wheelKey || remoteKey) {
      wheelRemoteInterval = setInterval(async () => {
        const token = safeLocalStorage.getItem('token')
        const keyBinding = safeLocalStorage.getItem(`keyBinding_${token?.user?.id}`)
        const gp = getActiveGamepad();
        if (gp) {
          if (keyBinding && gp.buttons[keyBinding[`Scan Checkpoint`]].pressed && !isCheckPointScanning.current) {
            onScreenShotClick()
          } else if (keyBinding && gp.buttons[keyBinding[`Menu`]].pressed) {
            if (modalIsOpenRef.current) {
              dispatch({
                type: actionTypes.MENU_OPEN_MODEL,
                payload: false
              })
              dispatch({
                type: actionTypes.HIDE_MENU,
                payload: false
              })
            } else {
              dispatch({
                type: actionTypes.MENU_OPEN_MODEL,
                payload: true
              })
              dispatch({
                type: actionTypes.HIDE_MENU,
                payload: true
              })
            }
          } else if (keyBinding && gp.buttons[keyBinding[`Toggle Speakers`]].pressed) {
            clearTimeout(speakersTimeOut)
            speakersTimeOut = setTimeout(async () => {
              let audioElm = document.getElementById('microphone');
              audioElm.muted = await audiosRef.current;
              if (audiosRef.current) {
                dispatch({
                  type: actionTypes.AUDIO_MUTED,
                  payload: false
                })
                audioRef?.current?.play()
              } else {
                dispatch({
                  type: actionTypes.AUDIO_MUTED,
                  payload: true
                })
                audioRef?.current?.pause()
              }
            }, 200)
          } else if (keyBinding && gp.buttons[keyBinding[`Toggle Microphone`]].pressed) {
            clearTimeout(micTimeOut)
            micTimeOut = setTimeout(async () => {
              const muteVal = await mute(micRef.current)
              if (micRef.current) {
                dispatch({
                  type: actionTypes.MIC_MUTED,
                  payload: false
                })
              } else {
                dispatch({
                  type: actionTypes.MIC_MUTED,
                  payload: true
                })
              }
            }, 200)
          } else if (keyBinding && gp.buttons[keyBinding[`Toggle Headlights`]].pressed) {
            clearTimeout(lightTimeOut)
            lightTimeOut = setTimeout(() => {
              if (headlightRef.current) {
                dispatch({
                  type: actionTypes.HEAD_LIGHT,
                  payload: false
                })
              } else {
                dispatch({
                  type: actionTypes.HEAD_LIGHT,
                  payload: true
                })
              }
            }, 200)
          }
        }
      }, 100)
    }
    return () => {
      clearInterval(wheelRemoteInterval)
    }
  }, [])

  useEffect(() => {
    if (keyboradKey) {
      keyboradKeyInterval = setInterval(() => {
        const token = safeLocalStorage.getItem('token')
        const keyBinding = safeLocalStorage.getItem(`keyBinding_${token?.user?.id}`)
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        keyboardControlHandeler(keyBinding)
      }, 200)
    }
    return () => {
      clearInterval(keyboradKeyInterval)
    }
  }, [])

  const keyboardControlHandeler = async (keyBinding) => {
    if (keyBinding && pressedKeys[keyBinding[`Scan Checkpoint`]] && !isCheckPointScanning.current) {
      onScreenShotClick();
    } else if (keyBinding && pressedKeys[keyBinding[`Menu`]]) {
      if (modalIsOpenRef.current) {
        dispatch({
          type: actionTypes.MENU_OPEN_MODEL,
          payload: false
        })
        dispatch({
          type: actionTypes.HIDE_MENU,
          payload: false
        })
      } else {
        dispatch({
          type: actionTypes.MENU_OPEN_MODEL,
          payload: true
        })
        dispatch({
          type: actionTypes.HIDE_MENU,
          payload: true
        })
      }
    } else if (keyBinding && pressedKeys[keyBinding[`Toggle Speakers`]]) {
      let audioElm = document.getElementById('microphone');
      audioElm.muted = await audiosRef.current;
      if (audiosRef.current) {
        dispatch({
          type: actionTypes.AUDIO_MUTED,
          payload: false
        })
        audioRef?.current?.play()
      } else {
        dispatch({
          type: actionTypes.AUDIO_MUTED,
          payload: true
        })
        audioRef?.current?.pause()
      }
    } else if (keyBinding && pressedKeys[keyBinding[`Toggle Microphone`]]) {
      const muteVal = await mute(micRef.current)
      if (micRef.current) {
        dispatch({
          type: actionTypes.MIC_MUTED,
          payload: false
        })
      } else {
        dispatch({
          type: actionTypes.MIC_MUTED,
          payload: true
        })
      }
    } else if (keyBinding && pressedKeys[keyBinding[`Toggle Headlights`]]) {
      if (headlightRef.current) {
        dispatch({
          type: actionTypes.HEAD_LIGHT,
          payload: false
        })
      } else {
        dispatch({
          type: actionTypes.HEAD_LIGHT,
          payload: true
        })
      }
    }
  }

  const handleKeyDown = (event) => {
    pressedKeys[event.key] = true;
  };

  const handleKeyUp = (event) => {
    pressedKeys[event.key] = false;
  };

  const onScreenShotClick = () => {
    setLoader(true)
    scanCheckpointHandler()
  };

  const scanCheckpointHandler = async () => {
    const token = safeLocalStorage.getItem('token')
    const captureDiv = document.querySelector("#front-cam");
    if (captureDiv) {
      const canvas = await html2canvas(captureDiv);
      canvas.width = captureDiv.videoWidth;
      canvas.height = captureDiv.videoHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(captureDiv, 0, 0, canvas.width, canvas.height);
      const screenshotDataURL = canvas.toDataURL('image/jpeg', 0.8);
      if (screenshotDataURL) {
        fetch(screenshotDataURL)
          .then(res => res.blob())
          .then(async blob => {
            const formData = new FormData();
            formData.append('image', blob);
            formData.append('username', token?.user?.username);
            formData.append('email', token?.user?.email);

            const config = {
              headers: {
                'Authorization': 'Basic YWYxYjZiZTQ2NDE4NDRiYWJhZjZjNzQ4ZTRiZjg2NGI6MzViOGU2ODFkMWE5NGRhY2FmYzg2YzExZmQ2YzI5NDY=',
                maxBodyLength: Infinity,
                'Content-Type': 'multipart/form-data'
              },
            }
            const uploadImage = await uploadScreenShotCamera(formData, config)
            if (uploadImage?.status === 'success' && uploadImage?.filename) {
              const encoded = encodeURIComponent(uploadImage?.filename);
              // const imagePath = {
              //   "image_url": `https://frodobots-image-api.s3.ap-southeast-1.amazonaws.com/images%2Fdivyesh_discord_2024-04-01T11%3A54%3A36.423107.jpg`
              // }
              const imagePath = {
                "image_url": `https://frodobots-image-api.s3.ap-southeast-1.amazonaws.com/${encoded}`
              }
              const getResponce = await gptCheckPoint(imagePath, testDriveRideIdRef.current)
              setLoader(false)
              if (getResponce?.data) {
                console.log('getResponce?.data: ', getResponce?.data);
                dispatch({
                  type: actionTypes.ALL_SCAN_CHECKPOINT_LIST,
                  payload: getResponce.data.checkpoints_list
                })
                dispatch({
                  type: actionTypes.SCAN_CHECKPOINT_LIST,
                  payload: getResponce.data?.checkpoints_list_scanned
                })
                dispatch({
                  type: actionTypes.GPT_SCAN_CHECKPOINT_RESPONECE,
                  payload: { ...getResponce.data, status: getResponce.status }
                })
                if (getResponce.data?.checkpoints_list_scanned?.length === 7 && getResponce?.data?.score) {
                  safeLocalStorage.setItem(`score_${token?.user?.id}`, getResponce?.data?.score)
                  findAllScanCheckPointAchieveTime(getResponce?.data?.score)
                  dispatch({
                    type: actionTypes.TEST_DRIVE_COMPLETE_SEVEN_POINT,
                    payload: true
                  })
                } else if (getResponce.data?.checkpoints_list_scanned?.length === 10 && getResponce?.data?.score) {
                  safeLocalStorage.setItem(`score_${token?.user?.id}`, getResponce?.data?.score)
                  findAllScanCheckPointAchieveTime(getResponce?.data?.score)
                  dispatch({
                    type: actionTypes.TEST_DRIVE_COMPLECT,
                    payload: true
                  })
                } else if (getResponce.status !== 201) {
                  dispatch({
                    type: actionTypes.GPT_ERROR_TOAST,
                    payload: true
                  })
                } else {
                  dispatch({
                    type: actionTypes.GPT_MESSAGE_TOAST,
                    payload: true
                  })
                }
              }
            }
          })
      }
    }
  }

  const findAllScanCheckPointAchieveTime = (secound) => {
    const minutes = Math.floor(secound / 60);
    const seconds = Math.floor(secound % 60);
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    const totalScanCheckPointTime = `${formattedMinutes}:${formattedSeconds}`
    dispatch({
      type: actionTypes.TIME_LEFT,
      payload: totalScanCheckPointTime
    })
  }

  let allcheckpointScan = false;
  if (scanCheckPointList?.length > 0 && allScanCheckpoint?.length > 0 && scanCheckPointList?.length === allScanCheckpoint?.length && scanCheckPointList?.length !== 0 && allScanCheckpoint?.length !== 0) {
    allcheckpointScan = true;
  }

  return (
    <div className="testdrive-botton-head">
      <SpeedDetails />
      <div className='scan-checkpoint-container' style={{ display: modalIsOpen ? 'none' : 'block', zIndex: (testDriveComplect || rulesOpenModel || suspiciousActivityModel) ? 0 : 1 }}>
        <div className='scan-checkpoint-div'>
          {
            loader ?
              <div className='scan-checkpoint-btn-grp-loader'>
                <button className='scan-checkpoint-loader'>Scanned! You may keep driving...</button>
              </div>
              :
              !allcheckpointScan ?
                <div className='scan-checkpoint-btn-grp' style={{ background: scanCheckPointList?.length >= 7 ? '#FCF552' : '#25BD66' }} onClick={onScreenShotClick}>
                  <button className='scan-checkpoint-letter' style={{ color: scanCheckPointList?.length >= 7 ? '#000000' : '#FAFAFA' }}>
                    Scan checkpoints
                  </button>
                </div>
                :
                <p className='complected-scanpoint-letter'>Completed in {timeLeft}! You can keep driving until time's up.</p>
          }
          <div className='testdrive-checkpoint-container' style={{ background: allcheckpointScan ? '#25BD66' : '#1B1B1B' }}>
            <div className='total-checkpint-container'>
              {allcheckpointScan ?
                <p className='checkpoint-number-letter'>🎉 {scanCheckPointList?.length}/{allScanCheckpoint?.length} Checkpoints 🎉</p>
                :
                (scanCheckPointList && allScanCheckpoint) && <p className='checkpoint-number-letter'>{scanCheckPointList?.length}/{allScanCheckpoint?.length} Checkpoints</p>
              }
            </div>
            <div className='total-checkpoint-indicator'>
              {
                scanCheckPointList?.length > 0 && scanCheckPointList.map((c, index) =>
                  <div className='checkpoint-number-show' style={{ background: allcheckpointScan ? '#FAFAFA' : '#25BD66' }} key={index}>
                    <p className='dot-icon' style={{ color: allcheckpointScan ? '#25BD66' : '#FAFAFA' }}>{c?.label}</p>
                  </div>
                )
              }
              {allScanCheckpoint?.length > 0 && Array.from(Array(allScanCheckpoint?.length - scanCheckPointList?.length)).map((i, index) =>
                (index === 0 && loader) ?
                  <div className='checkpoint-number-show' style={{ background: allcheckpointScan ? '#FAFAFA' : '#ffffff' }} key={index}>
                    <Oval
                      height={25}
                      width={25}
                      color="#000000"
                      visible={loader}
                      ariaLabel="oval-loading"
                      secondaryColor="#808080"
                      strokeWidth={5}
                      strokeWidthSecondary={3}
                    />
                  </div>
                  :
                  <div
                    className='checkpoint-number-show'
                    style={{
                      background: (gptErrorToast && index === 0) ? "#FCF552" : allcheckpointScan ? '#FAFAFA' : '#737373',
                      boxShadow: index < 7 ? '0 4px 8px rgba(128, 128, 128, 0.4)' : ''
                    }} key={index}>
                    <p className='dot-icon' style={{ color: '#000000' }}>.</p>
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Bottomheader